export default async (file) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  const promise = new Promise((resolve) => {
    reader.onload = () => {
      resolve(reader.result.split('base64,')[1]);
    };
  });

  return await promise;
}
